/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-10 08:38:48
 */

import {Component,Prop} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import ControlRecordService from "./service/controlRecordService";
import './controlRecord.less';
import { DeviceControlDOI } from './api/deviceControlApi';

@Component({name: 'control-record'})
export default class ControlRecord extends BasicSearchPage<ControlRecordService, DeviceControlDOI.RowDataI, DeviceControlDOI.QueryRowDataParamsI> {

    @Prop({
		type: String
	})
    mn!: string

    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new ControlRecordService(this)
	}
}